import { ApiService } from "../../../config";
import {
  TDeleteSystemTokenResponse,
  TSystemTokensResponse,
  TUser,
  TUserRes,
  TUserToken
} from "../models";
import { handleError } from "@/utils/parseApiReturn";

const getUsers = async (
  accountId: number,
  page: number,
  searchParam: string,
  limit: number
): Promise<TUserRes> => {
  try {
    const res = await ApiService.get(`/accounts/${accountId}/users`, {
      page,
      searchParam,
      limit
    });
    const { meta, success, users } = res.data;
    return {
      message: "",
      meta,
      success,
      data: users as TUser[]
    };
  } catch (error: unknown) {
    const { message, success } = handleError(
      error,
      "Erro inesperado ao obter os usuários:"
    );

    return {
      message,
      success,
      data: []
    };
  }
};

const regenerateToken = async (name: string): Promise<TUserToken> => {
  try {
    const res = await ApiService.get("/users/regenerate-token", { name });
    return res.data as TUserToken;
  } catch (error: unknown) {
    return handleError(error, "Erro na requisição para criar usuário:");
  }
};

const createUser = async (
  fullName: string,
  role: string,
  email: string,
  accountId: number
): Promise<any> => {
  try {
    const res = await ApiService.post(`/accounts/${accountId}/users`, {
      fullName,
      role,
      email
    });
    return res.data;
  } catch (error: unknown) {
    return handleError(error, "Erro na requisição para criar usuário:");
  }
};
const editUser = async (
  fullName: string,
  accountId: number,
  userId: number,
  role: string
): Promise<any> => {
  try {
    const res = await ApiService.patch(
      `/accounts/${accountId}/users/${userId}`,
      {
        fullName,
        role
      }
    );
    return res.data;
  } catch (error: any) {
    return handleError(error, "Erro na requisição para atualizar critério:");
  }
};

const deleteUser = async (accountId: number, userId: number): Promise<any> => {
  try {
    const res = await ApiService.delete(
      `/accounts/${accountId}/users/${userId}`
    );
    return res.data;
  } catch (error: any) {
    return handleError(error, "Erro na requisição para deletar usuário:");
  }
};

const getSystemTokens = async (
  page: number,
  limit: number,
  orderBy: string
): Promise<TSystemTokensResponse> => {
  try {
    const response = await ApiService.get(`/users/tokens`, {
      page,
      limit,
      orderBy
    });
    return response.data;
  } catch (error) {
    return handleError(
      error,
      "Erro na requisição para obter tokens do sistema"
    );
  }
};
const deleteSystemToken = async (
  tokenId: number
): Promise<TDeleteSystemTokenResponse> => {
  try {
    const res = await ApiService.delete(`users/tokens/${tokenId}`);
    return res.data;
  } catch (error: unknown) {
    return handleError(
      error,
      "Erro na requisição para excluir tokens do sistema"
    );
  }
};

export const UserService = {
  regenerateToken,
  getUsers,
  createUser,
  editUser,
  deleteUser,
  getSystemTokens,
  deleteSystemToken
};
